module.exports = __webpack_public_path__ + "static/media/p208model2.a45c0af8.jpg";